/** Toplam 100.000 ₺ sabit yapı — bilet çekilişi panel ataması (sıra ile kaydedilir) */
export const TICKET_RAFFLE_PRESET_SPEC = [
  { amountTry: 50000, count: 1, label: '50.000 ₺' },
  { amountTry: 20000, count: 1, label: '20.000 ₺' },
  { amountTry: 10000, count: 1, label: '10.000 ₺' },
  { amountTry: 2500, count: 4, label: '2.500 ₺' },
  { amountTry: 1000, count: 10, label: '1.000 ₺' }
];

export const TICKET_RAFFLE_PRESET_SLOTS = (() => {
  const slots = [];
  let idx = 0;
  for (const tier of TICKET_RAFFLE_PRESET_SPEC) {
    for (let i = 0; i < tier.count; i++) {
      idx += 1;
      slots.push({
        slotIndex: idx,
        amountTry: tier.amountTry,
        subtitle:
          tier.count > 1 ? `${tier.label} · ${i + 1}/${tier.count}` : tier.label
      });
    }
  }
  return slots;
})();

export const TICKET_RAFFLE_PRESET_TOTAL_SLOTS = TICKET_RAFFLE_PRESET_SLOTS.length;
export const TICKET_RAFFLE_PRESET_TOTAL_TRY = TICKET_RAFFLE_PRESET_SPEC.reduce(
  (s, t) => s + t.amountTry * t.count,
  0
);
